import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './Skeleton.css';

const BASE_COLOR = 'var(--border-color)';
const HIGHLIGHT_COLOR = 'var(--light-color)';

export function SkeletonLine({ width = '100%', height = 12, radius = 4, style }) {
  return (
    <SkeletonTheme baseColor={BASE_COLOR} highlightColor={HIGHLIGHT_COLOR}>
      <Skeleton width={width} height={height} borderRadius={radius} style={{ display: 'block', ...style }} />
    </SkeletonTheme>
  );
}

export function SkeletonBlock({ width = '100%', height = 40, radius = 8, style }) {
  return (
    <SkeletonTheme baseColor={BASE_COLOR} highlightColor={HIGHLIGHT_COLOR}>
      <Skeleton width={width} height={height} borderRadius={radius} style={{ display: 'block', ...style }} />
    </SkeletonTheme>
  );
}

export function SkeletonCircle({ size = 40, style }) {
  return (
    <SkeletonTheme baseColor={BASE_COLOR} highlightColor={HIGHLIGHT_COLOR}>
      <Skeleton circle width={size} height={size} style={{ display: 'block', flexShrink: 0, ...style }} />
    </SkeletonTheme>
  );
}

export function SkeletonTableRow({ columns = 4 }) {
  return (
    <div className="skeleton-table-row">
      {Array.from({ length: columns }).map((_, i) => (
        <SkeletonLine key={i} width={i === 0 ? '80%' : '60%'} height={14} />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 5, columns = 4 }) {
  return (
    <div className="skeleton-table" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonTableRow key={i} columns={columns} />
      ))}
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="skeleton-card" aria-hidden="true">
      <div className="skeleton-card-header">
        <SkeletonCircle size={36} />
        <div className="skeleton-card-header-text">
          <SkeletonLine width="50%" height={13} />
          <SkeletonLine width="30%" height={11} />
        </div>
      </div>
      <SkeletonLine width="95%" height={11} />
      <SkeletonLine width="80%" height={11} />
    </div>
  );
}

export function SkeletonCardGrid({ count = 6 }) {
  return (
    <div className="skeleton-card-grid" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export function SkeletonListRow() {
  return (
    <div className="skeleton-list-row" aria-hidden="true">
      <SkeletonCircle size={32} />
      <div className="skeleton-list-row-text">
        <SkeletonLine width="60%" height={12} />
        <SkeletonLine width="35%" height={10} />
      </div>
    </div>
  );
}

export function SkeletonListRows({ count = 4 }) {
  return (
    <div className="skeleton-list-rows" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonListRow key={i} />
      ))}
    </div>
  );
}

export function SkeletonProfileBlock() {
  return (
    <div className="skeleton-profile-block" aria-hidden="true">
      <SkeletonCircle size={72} />
      <SkeletonLine width="40%" height={16} />
      <SkeletonLine width="55%" height={12} />
      <div className="skeleton-profile-fields">
        <SkeletonBlock height={36} />
        <SkeletonBlock height={36} />
        <SkeletonBlock height={36} />
      </div>
    </div>
  );
}

export function SkeletonChatMessages({ count = 6 }) {
  return (
    <div className="skeleton-chat-messages" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`skeleton-chat-bubble-row ${i % 2 === 0 ? 'left' : 'right'}`}>
          <SkeletonCircle size={30} />
          <SkeletonBlock width={`${120 + (i % 3) * 60}px`} height={34} radius={12} />
        </div>
      ))}
    </div>
  );
}
